import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* providers */
import { LiquidacaoParcelaModelService } from './liquidacaoparcela.model.service';
import { PagamentoPIXModelService } from './pagamentopix.model.service';
import { ParametrosModelService } from './parametros.model.service';
import { ZoopModelService } from './zoop.model.service';
import { VitrineModelService } from './vitrine.model.service';
import { LojaModelService } from './loja.model.service';
import { ConsumidorSiteClientModelService } from './consumidorsiteclient.model.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    LiquidacaoParcelaModelService,
    PagamentoPIXModelService,
    ParametrosModelService,
    ZoopModelService,
    VitrineModelService,
    LojaModelService,
    ConsumidorSiteClientModelService
  ]
})
export class ModelServiceModule { }
